import { TTHTBullet } from "../../../../components/TTHTBullet";
import { Box } from "@material-ui/core";
import React from "react";
import {
  TTHTSectionContent,
  HideOnBreakpoint,
  TTHTSectionTitle,
  TTHTSectionText,
  TTHTSection,
  TTHTSectionWrapper,
} from "../../../TeachersToolkitHowTo.styled";

export const TTHTWelcomeSection = () => (
  <TTHTSection bgcolor="#FFFFFF">
    <TTHTSectionWrapper>
      <TTHTSectionContent>
        <TTHTSectionTitle>Toolkit User Guide</TTHTSectionTitle>
        <TTHTSectionText>
          Create your own toolkit form our range of tools so that you can build
          a brighter future for your students and the world they will inherit.
        </TTHTSectionText>
        <br />
        <TTHTBullet
          number={1}
          title="Select a year range"
          text="To access your materials, click on a year range (see above). A box will drop down with each individual year and its corresponding lessons."
        />
        <TTHTBullet
          number={2}
          title="Select a specific year"
          text="Simply click on the orange unit plan button or the specific year you want."
        />
      </TTHTSectionContent>
      <HideOnBreakpoint breakpoint="sm">
        <Box width="450px" display="flex" alignItems="flex-end" height="100%">
          <img
            className="img-fluid w-100"
            src="/img/teach/girl_with_globe.png"
          />
        </Box>
      </HideOnBreakpoint>
    </TTHTSectionWrapper>
  </TTHTSection>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/Welcome/TTHTWelcomeSection.js